import {observer} from 'mobx-react';
import React from 'react';
import {Portal} from '../../../../util';

interface RecycleIconProps {
    width: number;
    top: string;
    left: string;
}

const RecycledIcon: React.FC<RecycleIconProps> = observer(({width, top, left}) => {
    return (
        <img
            loading="lazy"
            src={`https://${Portal?.CDNDomain}/images/cached/general/recycled-logo1.png`}
            alt="Recycled"
            width={width}
            style={{position: 'absolute', top: top, left: left}}
        />
    );
});

export default RecycledIcon;
